const Layout = () => import('@/layout/index.vue')

export default  {
    meta: {
        title: '商品管理',
        icon: 'sidebar-default'
    },
    children: [{
        path: '/goods',
        component: Layout,
        redirect: '/goods/index',
        isLogin: false,
        meta: {
            title: '商品管理',
            icon: 'spgl',
            isShowIcon: true
        },
        children: [
            {
                path: 'index',
                name: 'GoodsIndex',
                component: () => import('@/views/goods/index.vue'),
                meta: {
                    title: '商品管理',
                    icon: 'merchant-account',
                    sidebar: false,
                    breadcrumb: false,
                    cache: ['GoodsRelease', 'GoodsRecycle']
                }
            },
            {
                path: 'release',
                name: 'GoodsRelease',
                component: () => import('@/views/goods/release.vue'),
                meta: {
                    title: '商品发布',
                    icon: 'merchant-account',
                    sidebar: false,
                    breadcrumb: false
                }
            },
            {
                path: 'recycle',
                name: 'GoodsRecycle',
                component: () => import('@/views/goods/recycle.vue'),
                meta: {
                    title: '回收站',
                    icon: 'merchant-account',
                    sidebar: false,
                    breadcrumb: false
                }
            }
        ]
    }]
}
